import { type App, createApp } from 'vue';
import crmRouter, { router } from '@crm-lib/routes/crmRouter';
import { type ApplicationInsightsOptions } from '@application-insights/aiSetup';
import axios from 'axios';
import { appDefaults } from '@app-lib/index';
import '@tailwind-preset/tailwind.css';
import application from './App.vue';

const app: App<Element> = createApp(application);

const aiOptions: ApplicationInsightsOptions = {
  applicationName: 'Crm',
  router,
  axios,
  trackInitialPageView: true,
};

app.use(appDefaults, aiOptions).use(crmRouter).mount('#app');
